import { useEffect, useState } from 'react';
import { ICreateOrgState } from '../../../redux/actions';
import { getEmailDomain, stripTopLevelDomain } from '../../../services/utils/emailHelper';
import { apiEndpoint, getZaplifySdk } from '@zaplify/sdk';
import { useMsal } from '@azure/msal-react';

const useDefineOrganizationForConfig = () => {
    const msal = useMsal();
    const [createOrgState, setCreateOrgState] = useState<ICreateOrgState>({
        action: 'none',
        domain: '',
        companyName: undefined,
    });

    useEffect(() => {
        (async () => {
            const profilesSdk = getZaplifySdk(apiEndpoint, msal.instance).profiles;

            try {
                const msUser = msal.instance.getActiveAccount();
                const domain = getEmailDomain(msUser.idTokenClaims.email as string);
                const organizationMatchingDomain = await profilesSdk.user.getUserOrganizationByDomain(domain);
                const accounts = await profilesSdk.user.getUserAccounts();
                const userHasAccountWithDomain = accounts.some((account) =>
                    domain.includes(account.organization.name.toLowerCase())
                );

                if (organizationMatchingDomain && !userHasAccountWithDomain) {
                    setCreateOrgState({ action: 'join', domain });
                } else {
                    const cleanedDomain = stripTopLevelDomain(domain);
                    if (cleanedDomain) {
                        //do something
                        setCreateOrgState({
                            action: 'create',
                            companyName: cleanedDomain[0].toUpperCase() + cleanedDomain.slice(1),
                            domain,
                        });
                    }
                }
            } catch (error) {
                console.error(
                    'Could not find any organization matching your domain, and could not create organization. Please contact support.',
                    error
                );
            }
        })();
    }, []);

    return { organization: createOrgState };
};

export default useDefineOrganizationForConfig;
